import {
  OBJECT_STORAGE_CLEAN_REQUEST,
  OBJECT_STORAGE_FETCH_REQUEST,
  OBJECT_STORAGE_FETCH_REQUEST_FAILURE,
  OBJECT_STORAGE_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const objectStorageReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case OBJECT_STORAGE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case OBJECT_STORAGE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case OBJECT_STORAGE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    case OBJECT_STORAGE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

export default objectStorageReducer;
